import { render, staticRenderFns } from "./PreviewPractice.vue?vue&type=template&id=341369fe&scoped=true&"
import script from "./PreviewPractice.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PreviewPractice.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PreviewPractice.vue?vue&type=style&index=0&id=341369fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341369fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('341369fe')) {
      api.createRecord('341369fe', component.options)
    } else {
      api.reload('341369fe', component.options)
    }
    module.hot.accept("./PreviewPractice.vue?vue&type=template&id=341369fe&scoped=true&", function () {
      api.rerender('341369fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/mobile/PreviewPractice.vue"
export default component.exports